import { BookOpen, Map, Presentation, Settings2 } from 'lucide-react'

type ReferenceView = 'overview' | 'plan-2d' | 'presentation' | 'editor'

type Props = {
  active: ReferenceView
  onOverview: () => void
  onCanvas: () => void
  onPresentation: () => void
  onEditor: () => void
}

export function ReferenceViewNav({ active, onOverview, onCanvas, onPresentation, onEditor }: Props) {
  return (
    <nav className="project-view-nav reference-view-nav" aria-label="Outils de la référence générale">
      <div>
        <button className={active === 'overview' ? 'active' : ''} onClick={onOverview} type="button"><BookOpen size={18} /> Référence générale</button>
        <button className={active === 'plan-2d' ? 'active' : ''} onClick={onCanvas} type="button"><Map size={18} /> Parcours visuel général</button>
        <button className={active === 'presentation' ? 'active' : ''} onClick={onPresentation} type="button"><Presentation size={18} /> Présentation générale</button>
        <button className={active === 'editor' ? 'active' : ''} onClick={onEditor} type="button"><Settings2 size={18} /> Préparer une nouvelle version</button>
      </div>
    </nav>
  )
}
